import { VEHICLE_TYPES, VEHICLE_TYPE_EV } from '../../../../../constants/vehicleTypes';

const SIMPLE_SEARCH_FIELDS = {
  [VEHICLE_TYPES.CARS]: ['l2CategoryId', 'model', 'constructionYear', 'priceType', 'PriceCents', 'fuel'],
  [VEHICLE_TYPES.VANS]: ['brand', 'transmission', 'constructionYear', 'priceType', 'PriceCents', 'fuel'],
  [VEHICLE_TYPES.OLDTIMERS]: ['brand', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPES.TRUCKS]: ['brand', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPE_EV]: ['l2CategoryId', 'model', 'PriceCents', 'fuel', 'range', 'batteryCapacity'],
};

export default SIMPLE_SEARCH_FIELDS;
